// src/data/comedians/adel-imam.js

const base = {
  id: 'adel-imam',
  slug: 'adel-imam',
  name: 'Adel Imam',
  birthYear: 1940,
  image: require('@/assets/images/img_Adel_Imam.jpg'),
  famousWorks: [
    'The Terrorist (1994)',
    'Al-Irhab wal Kabab (1992)',
    'Al-Mansy (1993)',
    'Al-Zaeem (The Leader) series',
    'Birds of Darkness (1995)',
    'Hassan and Morcos (2008)',
    'The Yacoubian Building (2006)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'Egyptian',
    shortBio: 'Arab comedy legend and cultural icon',
    bio: `Adel Imam is an Egyptian actor and comedian widely regarded as one of the greatest and most influential comedians in the Arab world. Known as "El Za'eem" (The Leader), Imam has dominated Arabic cinema and television for over five decades, using comedy to address social and political issues.\n\nBorn in Al Mansoura, Egypt, Imam studied agriculture at Cairo University but found his true calling in theater and comedy. He began his career in the 1960s in university theater before transitioning to film and television.\n\nImam's films have broken box office records throughout the Middle East and North Africa. He has fearlessly tackled corruption, religious extremism, and social hypocrisy through his comedy, making him deeply beloved by millions across the Arab world.`,
    style: 'Social satire, physical comedy, political commentary, relatable characters',
    achievements: [
      'Best Actor at numerous Arab film festivals',
      'Cairo International Film Festival lifetime achievement',
      'Star on the Egyptian Walk of Fame',
      'UN Goodwill Ambassador',
      'Most commercially successful actor in Arab cinema history',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Égyptien',
    shortBio: 'Légende de la comédie arabe et icône culturelle',
    bio: `Adel Imam est un acteur et comédien égyptien largement considéré comme l'un des plus grands et influents comédiens du monde arabe. Connu sous le nom de « El Za'eem » (Le Leader), Imam a dominé le cinéma et la télévision arabes pendant plus de cinq décennies.\n\nNé à Al Mansoura en Égypte, il a étudié l'agriculture à l'Université du Caire avant de trouver sa vocation dans le théâtre et la comédie. Il débute sa carrière dans les années 1960 au théâtre universitaire avant de passer au cinéma et à la télévision.\n\nSes films ont battu des records au box-office au Moyen-Orient et en Afrique du Nord. Il a abordé sans crainte la corruption, l'extrémisme religieux et l'hypocrisie sociale à travers sa comédie, ce qui lui a valu l'amour de millions de spectateurs.`,
    style: 'Satire sociale, comédie physique, commentaire politique, personnages attachants',
    achievements: [
      'Meilleur acteur dans de nombreux festivals de cinéma arabes',
      'Récompense pour l\'ensemble de sa carrière au Festival du Caire',
      'Étoile sur le Walk of Fame égyptien',
      'Ambassadeur de bonne volonté de l\'ONU',
      'Acteur le plus rentable de l\'histoire du cinéma arabe',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Egipcio',
    shortBio: 'Leyenda de la comedia árabe e icono cultural',
    bio: `Adel Imam es un actor y comediante egipcio ampliamente considerado como uno de los más grandes e influyentes comediantes del mundo árabe. Conocido como "El Za'eem" (El Líder), Imam ha dominado el cine y la televisión árabe durante más de cinco décadas.\n\nNacido en Al Mansoura, Egipto, estudió agricultura en la Universidad de El Cairo pero encontró su verdadera vocación en el teatro y la comedia. Comenzó su carrera en los años 60 en el teatro universitario antes de pasar al cine y la televisión.\n\nSus películas han roto récords de taquilla en todo el Medio Oriente y el Norte de África. Ha abordado sin miedo la corrupción, el extremismo religioso y la hipocresía social a través de su comedia, ganándose el amor de millones.`,
    style: 'Sátira social, comedia física, comentario político, personajes entrañables',
    achievements: [
      'Mejor Actor en numerosos festivales de cine árabe',
      'Premio a la trayectoria en el Festival Internacional de Cine de El Cairo',
      'Estrella en el Paseo de la Fama egipcio',
      'Embajador de buena voluntad de la ONU',
      'Actor con mayor recaudación en la historia del cine árabe',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'مصري',
    shortBio: 'أسطورة الكوميديا العربية وأيقونتها الثقافية',
    bio: `عادل إمام ممثل وكوميدي مصري يُعدّ على نطاق واسع من أعظم الكوميديين وأكثرهم تأثيرًا في العالم العربي. يُعرف بلقب "الزعيم"، وقد هيمن على السينما والتلفزيون العربي لأكثر من خمسة عقود، مستخدمًا الكوميديا لمعالجة القضايا الاجتماعية والسياسية.\n\nوُلد في المنصورة بمصر، درس الزراعة في جامعة القاهرة قبل أن يجد نفسه في عالم المسرح والكوميديا. بدأ مسيرته في الستينيات بالمسرح الجامعي ثم انتقل إلى السينما والتلفزيون.\n\nحققت أفلامه أرقامًا قياسية في شباك التذاكر عبر الشرق الأوسط وشمال أفريقيا. تناول بجرأة الفساد والتطرف الديني والنفاق الاجتماعي من خلال فنه الكوميدي، ما جعله محبوبًا لدى الملايين في أرجاء العالم العربي.`,
    style: 'السخرية الاجتماعية، الكوميديا الجسدية، التعليق السياسي، الشخصيات المحبوبة',
    achievements: [
      'أفضل ممثل في عدد كبير من مهرجانات الأفلام العربية',
      'جائزة الإنجاز مدى الحياة في مهرجان القاهرة السينمائي الدولي',
      'نجمة على ممشى المشاهير المصري',
      'سفير للنوايا الحسنة للأمم المتحدة',
      'أكثر الممثلين نجاحًا تجاريًا في تاريخ السينما العربية',
    ],
  },
];
